import ContractTransactions from './ContractTransactions';

export default ContractTransactions;
